<template>
  <div class="">
    <VueGoodTable
      mode="remote"
      @on-page-change="onPageChange"
      @on-sort-change="onSortChange"
      @on-per-page-change="onPerPageChange"
      @on-search="onSearch"
      :isLoading.sync="isLoading"
      :columns="columns"
      :rows="tags"
      :totalRows="totalRecords"
      :search-options="{
        enabled: true,
        placeholder: 'Tìm kiếm',
      }"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        rowsPerPageLabel: 'Số hàng mỗi trang',
        nextLabel: 'Trang sau',
        prevLabel: 'Trang trước',
        ofLabel: 'trong',
      }"
      styleClass="vgt-table striped bordered"
    >
      <div slot="emptystate">Danh sách tài liệu của bạn đang trống</div>

      <template slot="table-row" slot-scope="props">
        <div v-if="props.column.field === 'action'" class="d-flex flex-row justify-content-around">
          <FAIcon
            icon="fas fa-pen-nib"
            title="Chỉnh sửa thư mục"
            :color="Colors.EDIT"
            @click="$refs[refs.TAG_EDIT_MODAL].openModal(props.row)"
          />
          <FAIcon
            icon="fas fa-paper-plane"
            title="Chia sẻ thư mục"
            :color="Colors.SEND"
            @click="$refs[refs.TAG_SHARE_MODAL].openModal(props.row)"
          />
        </div>

        <span v-else-if="props.column.field === 'name'">
          <router-link :to="Paths.TAG_DETAIL(props.row.id)">
            {{ props.row.name }}
          </router-link>
          <el-tooltip
            class="item share"
            effect="dark"
            placement="right-start"
            v-if="props.row.sharedUsers && props.row.sharedUsers.length > 0"
          >
            <div slot="content" v-html="getShareUsers(props.row.sharedUsers)"></div>
            <FAIcon icon="fas fa-users" />
          </el-tooltip>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <template slot="loadingContent">
        <span class="vgt-loading__content"> Đang tải... </span>
      </template>
    </VueGoodTable>
    <TagEditModal :ref="refs.TAG_EDIT_MODAL" @success="loadItems" />
    <TagShareModal :ref="refs.TAG_SHARE_MODAL" @success="loadItems" />
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table"
import { getAllTag } from "@/services/tag_management_service"
import truncate from "vue-truncate-collapsed"
import { Table } from "@/constants/DoITConstant"
import { Paths } from "@/routes/paths.js"
import TagEditModal from "@/components/TagsManagement/tag-actions/TagEditModal.vue"
import FAIcon from "@/components/common/FAIcon.vue"
import { Colors } from "@/constants/DoITConstant.js"
import { formatDateTime } from "@/helpers/timeHelper.js"
import TagShareModal from "@/components/TagsManagement/tag-actions/TagShareModal.vue"

export default {
  name: "TagList",
  components: {
    TagShareModal,
    FAIcon,
    TagEditModal,
    VueGoodTable,
    truncate,
  },
  data: function () {
    return {
      columns: [
        {
          label: "ID",
          field: "id",
        },
        {
          label: "Tên thư mục",
          field: "name",
        },
        {
          label: "Ngày tạo",
          field: "createTime",
          formatFn: formatDateTime,
        },
        {
          label: "Hành động",
          field: "action",
          width: "100px",
        },
      ],
      totalRecords: 0,
      serverParams: {
        sortAscending: false,
        sortField: "createTime",
        page: 0,
        size: 10,
      },
      tags: [],
      interval: null,
      isLoading: true,
      selectedRows: [],
      Paths,
      Colors,
      refs: {
        TAG_EDIT_MODAL: "tagEditModal",
        TAG_SHARE_MODAL: "tagShareModal",
      },
    }
  },
  async mounted() {
    this.loadItems().then()
    this.interval = setInterval(() => {
      if (this.selectedRows.length === 0) {
        this.loadItems()
      }
    }, Table.RELOAD_INTERVAL)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    onSearch(params) {
      this.serverParams.searchKey = params.searchTerm
      this.loadItems()
    },

    onPageChange(params) {
      this.serverParams.page = params.currentPage - 1
      this.loadItems()
    },

    onPerPageChange(params) {
      this.serverParams.size = params.currentPerPage
      this.loadItems()
    },

    onSortChange(params) {
      this.serverParams.sortAscending = params[0].type === "asc"
      this.serverParams.sortField = params[0].field
      this.serverParams.page = 0
      this.loadItems()
    },
    async loadItems() {
      this.isLoading = true
      let responseAllDocument = await getAllTag(this.serverParams)
      this.tags = responseAllDocument.data
      this.totalRecords = responseAllDocument.meta.total
      this.isLoading = false
    },
    getShareUsers(shareUsers) {
      let tooltip = "Đã chia sẻ cho: " + "<br/>"
      let count = 0
      for (let i = 0; i < shareUsers.length; i++) {
        let name = shareUsers[i]
        if (name != null) {
          count++
          if (count > 2) {
            let remain = shareUsers.length - count + 1
            tooltip = tooltip + "và " + remain + " thư mục khác <br/>"
          } else {
            tooltip = tooltip + shareUsers[i] + "<br/>"
          }
        }
      }

      return tooltip
    },
  },
}
</script>
